import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t, Fragment as n } from "react/jsx-runtime";
import { calculateRem as e, withVDSManager as r } from "@vds-core/utilities";
import { LayoutTokens as i } from "@vds-tokens/layout";
import { Component as o, Fragment as a } from "react";
import s from "styled-components";
import { spacingForButton as u, spacingForTextLink as c, spacingForTextLinkCaret as d } from "../util/spacingUtil.js";
import l from "./ButtonGroupItem.js";
var p = function p(t, n, e) {
    return "primary" === n || "secondary" === n ? u(e) : "textLink" === n ? c(e, t) : d(e);
  },
  h = function h(t, n) {
    var e;
    var r = function r(t, n) {
        return t && t.find(function (t) {
          return t.use === n;
        });
      },
      i = function i(t) {
        return t && t.size;
      },
      o = r(t, "primary") || r(t, "secondary"),
      a = r(n, "primary") || r(n, "secondary"),
      s = r(t, "textLinkCaret"),
      u = r(n, "textLinkCaret"),
      c = r(t, "textLink");
    return o ? e = "small" === i(o) ? a ? "3X" : "6X" : a ? "3X" : u ? "6X" : "4X" : s ? e = "6X" : c && (e = "small" === i(c) ? a ? "6X" : "8X" : a ? "4X" : "6X"), e;
  },
  m = s.div.withConfig({
    displayName: "ButtonGroupWrapper",
    componentId: "VDS__sc-9qyslt-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: ", ";\n"])), function (_ref) {
    var t = _ref.$maxWidth,
      n = _ref.$rowQuantity;
    return 1 !== n && t;
  }, function (_ref2) {
    var t = _ref2.width;
    return t || "100%";
  }),
  f = s.div.withConfig({
    displayName: "ButtonGroupRow",
    componentId: "VDS__sc-9qyslt-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  padding-bottom: ", ";\n  justify-content: ", ";\n  &:last-child {\n    padding-bottom: 0;\n  }\n"])), function (_ref3) {
    var t = _ref3.spacing,
      n = _ref3.$totalGroupItems;
    return n && n > 1 && t ? e(i.space[t].value) : 0;
  }, function (_ref4) {
    var t = _ref4.alignment;
    return t;
  });
var g = /*#__PURE__*/function (_o) {
  _inherits(g, _o);
  function g() {
    var _this;
    _classCallCheck(this, g);
    var r;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(g).apply(this, arguments)), r = _assertThisInitialized(_assertThisInitialized(_this)), _this._onClick = function (t, n) {
      n && n(t), r.props.onClick && r.props.onClick(t);
    }, _this._calculateWidth = function (t, n, i) {
      var o;
      var a = parseInt(n, 10);
      return r.props.width ? r.props.width : (t && i ? ("%" === t[t.length - 1] ? (o = parseInt(t, 10) / 100, o *= 596) : o = parseInt(t, 10) * i, o = e(o < a ? o : a)) : o = e(a), o);
    }, _this._getRowQuantityValue = function (t) {
      var n = r.props.viewport;
      return "mobileLarge" !== n || t[n] ? "tabletLarge" !== n || t[n] ? "desktopLarge" !== n && "desktopXLarge" !== n || t[n] ? t[n || "desktop"] : t.desktop : t.tablet : t.mobile;
    }, _this.renderButtonGroupRows = function (e) {
      var _r$props = r.props,
        i = _r$props.data,
        o = _r$props.alignment;
      if (!i) return null;
      var a = [];
      for (var _t = 0; _t < i.length; _t += e) {
        var _n = i.slice(_t, _t + e);
        a.push(_n);
      }
      return t(n, {
        children: a.map(function (n, s) {
          var u = s < a.length - 1 && a[s + 1];
          return t(f, {
            alignment: o,
            $totalGroupItems: i.length,
            spacing: h(n, u),
            children: r.renderButtonGroupItems(n, e)
          }, s);
        })
      });
    }, _this.renderButtonGroupItems = function (e, i) {
      var _r$props2 = r.props,
        o = _r$props2.childWidth,
        s = _r$props2.dataLoc,
        u = _r$props2.surface;
      return t(n, {
        children: e.map(function (n, c) {
          var d = n.children,
            h = n.size,
            m = n.use,
            f = n.width,
            g = n.$noVerticalPadding,
            w = n.ariaLabel,
            y = f || o,
            $ = y,
            k = c < e.length - 1 ? e[c + 1].use : void 0;
          return t(a, {
            children: t(l, Object.assign({}, n, {
              ariaLabel: w,
              $rowQuantity: i,
              size: h,
              use: m,
              width: y,
              onClick: function onClick(t) {
                return r._onClick(t, n.onClick);
              },
              index: c,
              $noVerticalPadding: g,
              $calculateButtonSpacing: p,
              $nextButtonType: k,
              dataLoc: s,
              $groupWidth: $,
              surface: u,
              children: d
            }))
          }, c);
        })
      });
    };
    return _this;
  }
  _createClass(g, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        n = _this$props.data,
        e = _this$props.childWidth,
        r = _this$props.rowQuantity,
        i = _this$props.maxWidth,
        o = _this$props.className,
        a = _this$props.width,
        s = r && this._getRowQuantityValue(r);
      return t(m, {
        $maxWidth: this._calculateWidth(e, i, s),
        $rowQuantity: s,
        className: o,
        width: a,
        children: s ? this.renderButtonGroupRows(s) : this.renderButtonGroupItems(n, s)
      });
    }
  }]);
  return g;
}(o);
g.defaultProps = {
  viewport: "desktop",
  $noVerticalPadding: !1,
  maxWidth: void 0,
  surface: "light",
  childWidth: "auto",
  alignment: "center"
};
var w = r(g, !0);
export { w as default };